import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type SocketState = {
  socket_connected: boolean
  socket: WebSocket | null
}

const initialState: SocketState = {
  socket_connected: false,
  socket: null,
}

const socketSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    socketConnectionInit(state, action: PayloadAction<{ socket: WebSocket }>) {
      state.socket = action.payload.socket
    },
    socketConnectionSuccess(state) {
      state.socket_connected = true
    },
    socketConnectionError(state) {
      console.log('socket error')
      state.socket_connected = false
      state.socket = null
    },
    socketConnectionClosed(state) {
      console.log('socket close')
      state.socket_connected = false
      state.socket = null
    },
  },
})
export const {
  socketConnectionInit,
  socketConnectionSuccess,
  socketConnectionError,
  socketConnectionClosed,
} = socketSlice.actions

export default socketSlice.reducer
